import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../components/ui';
import { CharacterCard, Character } from '../components/CharacterCard';
const FULL_CAST: Character[] = [{
  id: 'vinny',
  name: 'Vinny Capuano',
  hometown: 'Brooklyn, NY',
  color: 'bg-blue-900',
  borderColorClass: 'border-blue-500',
  tagline: 'Settles every argument with a deli meat analogy.',
  quote: "Whaddya think you're doin' startin' Deebo on a BYE week? You absolute stunad. My grandmother could run a better route, and she's been dead since '04.",
  bio: "Vinny runs a deli in Bensonhurst and hasn't missed a Sunday kickoff since 1998. He thinks analytics are ruining the game and believes every problem can be solved by 'running the damn ball.' He will yell at you.",
  catchphrases: ['You stunad!', 'Fuhgeddaboudit.', 'My grandmother could run a better route.']
}, {
  id: 'dale',
  name: 'Dale & Earl',
  hometown: 'Harlan County, KY',
  color: 'bg-green-900',
  borderColorClass: 'border-green-600',
  tagline: 'Two cousins. One microphone. Zero indoor voices.',
  quote: "Well I'll be dadgum... you started WHO? Boy, even the mule woulda known better than to trust a Jets quarterback on a Thursday.",
  bio: "Two cousins sharing one microphone from the cab of a 1994 Ford F-150. They measure player performance in 'horsepower' and 'grit'. They don't know what a PPR is, but they know you suck at it.",
  catchphrases: ['Lord have mercy.', "That boy's softer than a sneaker full of puppy poop.", 'Earl, get the jumper cables.']
}, {
  id: 'marisol',
  name: 'Marisol Cruz',
  hometown: 'South Bronx, NY',
  color: 'bg-rose-900',
  borderColorClass: 'border-rose-500',
  tagline: 'Every emotion at 100%. Every play is life or death.',
  quote: 'Ay, mira — Josh Allen casi me da un ataque al corazón. CASI, David! I am lighting a candle for your absolutely pathetic roster.',
  bio: "Your extremely passionate, slightly terrifying aunt who somehow knows more about defensive schemes than the actual coaches. She will pray for your team, but mostly she'll just yell.",
  catchphrases: ['¡Dios mío!', 'You call that a tackle?', "I'm lighting a candle for your roster."]
}, {
  id: 'giuseppe',
  name: 'Giuseppe Conti',
  hometown: 'Palermo, Sicily',
  color: 'bg-red-950',
  borderColorClass: 'border-red-800',
  tagline: 'Silence is his weapon. Disappointment is his art.',
  quote: '...You benched Jefferson. (long, agonizing pause) ...I have nothing more to say to you. You are dead to me.',
  bio: "A man of few words, but immense disappointment. Giuseppe doesn't yell. He just makes you feel profound, existential shame about your flex spot. He makes you want to apologize to your father.",
  catchphrases: ['*Heavy sigh*', 'This is a dishonor.', 'We do not speak of this week.']
}, {
  id: 'daniel',
  name: 'Daniel Ashworth',
  hometown: 'London, UK',
  color: 'bg-slate-800',
  borderColorClass: 'border-slate-400',
  tagline: 'Forty years of rugby did not prepare him for this.',
  quote: "I've watched 40 years of rugby. I've seen men lose teeth and keep running. But nothing prepared me for the absolute cowardice of your flex spot.",
  bio: 'A proper English gentleman trying to understand American football. He treats every fumble like a national tragedy and every touchdown like a mild inconvenience.',
  catchphrases: ['Absolute rubbish.', "What on earth is a 'flea flicker'?", 'I need a pint after that.']
}, {
  id: 'gary',
  name: "G'Day Gary",
  hometown: 'Melbourne, AU',
  color: 'bg-orange-900',
  borderColorClass: 'border-orange-500',
  tagline: 'Volume permanently set to 11. Pads are for cowards.',
  quote: 'STREWTH mate, that was more painful than taking a box jellyfish straight to the face! Absolute RIPPER of a choke job!',
  bio: 'Gary is always at a volume of 11. He thinks pads are for cowards and treats fantasy football like a blood sport. He has definitely wrestled a crocodile.',
  catchphrases: ['CRIKEY!', 'Put another shrimp on the barbie, your team is cooked!', 'Absolute madness!']
}, {
  id: 'kevin',
  name: 'Kevin Chen',
  hometown: 'Flushing, Queens, NY',
  color: 'bg-red-900',
  borderColorClass: 'border-red-600',
  tagline: 'He came for dumplings. He stayed for the fantasy roast.',
  quote: 'YOU START DANIEL JONES?! My grandmother in Flushing make better decision with her eyes closed! DANIEL JONES! I drop my dumpling watching this!',
  bio: 'Mid-50s Asian-American man from Flushing. Speaks completely fluent American sports rage with a thick accent — the contrast is the joke. Will compare your bad picks to bad dumpling fillings.',
  catchphrases: ['My grandmother make better decision!', 'You call that a defense?!', 'I drop my dumpling watching this!']
}, {
  id: 'marcus',
  name: 'Marcus — The Flamboyant',
  hometown: 'West Hollywood, CA',
  color: 'bg-fuchsia-900',
  borderColorClass: 'border-fuchsia-500',
  tagline: 'The audacity. The sheer unmitigated audacity.',
  quote: 'Honey... you started WHO at flex? The disrespect to my intelligence. The absolute GALL. That lineup is a hate crime against fashion.',
  bio: 'Extremely fabulous, late 30s. Cocktail in hand, pointing dramatically at the camera. Treats your lineup choices like personal affronts to good taste.',
  catchphrases: ['The sheer unmitigated audacity.', 'I am SHAKEN.', 'That lineup is a hate crime against fashion.']
}, {
  id: 'commentator',
  name: 'The Commentator',
  hometown: 'Unknown',
  color: 'bg-slate-900',
  borderColorClass: 'border-white/50',
  tagline: 'Pure energy. No identity. Just vibes and violence.',
  quote: 'AND HE FUMBLES ON THE ONE YARD LINE! THE ABSOLUTE DISASTER CLASS WE ARE WITNESSING TODAY! I AM SICK TO MY STOMACH!',
  bio: 'A silhouette figure with a microphone. No one knows who he is, but he screams with the intensity of a man who bet his life savings on the under.',
  catchphrases: ['ARE YOU KIDDING ME?!', 'UNBELIEVABLE!', 'THAT IS A TRAGEDY!']
}, {
  id: 'ricky',
  name: 'Ricky Rotardo',
  hometown: 'Every Last Place Finish',
  color: 'bg-yellow-900',
  borderColorClass: 'border-yellow-400',
  tagline: 'The name no one wants to be compared to.',
  quote: "Ricky Rotardo isn't a voice. He's a warning. When Vinny says 'you're playing like Ricky Rotardo,' you know you've hit rock bottom.",
  bio: "Ricky is the platform's recurring villain. He doesn't speak — he is spoken about. He is the fictional disaster player that the commentators reference when roasting owners. He is the measuring stick for incompetence.",
  catchphrases: ['(Silence, because he is in last place)', '(Crying softly)']
}];
const JORGE: Character = {
  id: 'jorge',
  name: 'Jorge (The Interrupt)',
  hometown: 'Mexico City, MX',
  color: 'bg-red-600',
  borderColorClass: 'border-red-500',
  quote: '—¡NO MAMES! ¡TOUCHDOWN! ¡TOUCHED—',
  bio: "Jorge doesn't wait his turn. He is a special mechanic that randomly interrupts other commentators during massive plays or catastrophic fumbles. He has no chill.",
  catchphrases: ['¡GOLAZO!', '¡Ay caramba!', '¡No puede ser!'],
  isInterrupt: true
};
export const CharactersPage = () => {
  return <div className="w-full pt-20" data-id="element-459">
      {/* HERO */}
      <section className="py-24 bg-stadium-grain bg-cover bg-center relative border-b border-white/10" data-id="element-460">
        <div className="absolute inset-0 bg-charcoal/80 backdrop-blur-sm" data-id="element-461"></div>
        <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-462">
          <SectionHeading title="THE CAST" subtitle="9 distinct voices. Infinite ways to get roasted. Build your perfect commentary booth of doom." className="mb-0 mx-auto flex flex-col items-center" data-id="element-463" />
        </div>
      </section>

      {/* GRID */}
      <section className="py-24 bg-charcoal" data-id="element-464">
        <div className="container mx-auto px-4" data-id="element-465">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-466">
            {FULL_CAST.map(char => <CharacterCard key={char.id} character={char} expanded={true} data-id="element-467" />)}
          </div>
        </div>
      </section>

      {/* THE INTERRUPT SECTION */}
      <section className="py-24 bg-dark border-y border-white/10 relative overflow-hidden" data-id="element-468">
        <div className="absolute inset-0 bg-red-900/10" data-id="element-469"></div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-470">
          <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-471">
            <div className="lg:w-1/2" data-id="element-472">
              <h2 className="text-sm font-bold uppercase tracking-wider text-red-500 mb-4" data-id="element-473">
                Special Mechanic
              </h2>
              <h3 className="text-5xl md:text-7xl font-black font-heading uppercase -skew-x-6 mb-6 text-white" data-id="element-474">
                PLUS: THE INTERRUPT
              </h3>
              <p className="text-xl text-slate mb-8" data-id="element-475">
                Jorge doesn't wait his turn. When a massive 50+ yard play
                happens, or someone fumbles on the goal line, Jorge will
                literally cut off the other commentators mid-sentence. It is
                chaotic and beautiful.
              </p>
              <div className="bg-charcoal p-6 rounded-2xl border border-white/10 relative" data-id="element-476">
                <p className="text-slate italic mb-2" data-id="element-477">Audio transcript:</p>
                <p className="text-white font-medium" data-id="element-478">
                  <span className="text-blue-400" data-id="element-479">Vinny:</span> "Look, I told
                  you not to start him, he's got hands like frying pa—"
                </p>
                <p className="text-red-500 font-bold text-xl mt-2 animate-pulse" data-id="element-480">
                  <span className="text-white" data-id="element-481">Jorge:</span> "¡NO MAMES!
                  ¡TOUCHDOWN DE OCHENTA YARDAS! ¡VÁMONOS!"
                </p>
              </div>
            </div>
            <div className="lg:w-1/2 w-full max-w-md" data-id="element-482">
              <CharacterCard character={JORGE} expanded={true} data-id="element-483" />
            </div>
          </div>
        </div>
      </section>

      {/* SPANGLISH SIDEBAR */}
      <section className="py-24 bg-charcoal" data-id="element-484">
        <div className="container mx-auto px-4 text-center max-w-4xl" data-id="element-485">
          <h2 className="text-4xl md:text-6xl font-black font-heading uppercase -skew-x-6 mb-6 text-lime" data-id="element-486">
            SPANGLISH SIDEBAR
          </h2>
          <p className="text-xl text-slate mb-12" data-id="element-487">
            Pair Marisol and Jorge together to unlock the "Spanglish Sidebar" —
            a special commentary mode where they argue with each other in two
            languages while completely ignoring your fantasy score. It's like
            Thanksgiving dinner.
          </p>
          <div className="flex justify-center gap-4" data-id="element-488">
            <div className="w-20 h-20 rounded-full bg-rose-900 border-2 border-rose-500 flex items-center justify-center text-2xl font-black font-heading" data-id="element-489">
              M
            </div>
            <div className="flex items-center text-lime font-bold text-2xl" data-id="element-490">
              +
            </div>
            <div className="w-20 h-20 rounded-full bg-red-600 border-2 border-red-500 flex items-center justify-center text-2xl font-black font-heading" data-id="element-491">
              J
            </div>
          </div>
        </div>
      </section>
    </div>;
};